import React from 'react'
import styled from 'particles/themes/styled'
import { theme } from 'theme'
import Text from 'particles/Text'

export const ErrorDots = styled.div`
    width: 6px !important;
    height: 6px !important;
    border-radius: 50%;
    background-color: ${theme.newColors.alertError200};
    position: absolute;
    top: 9px;
    right: -9px;
`

const ErrorDotTitle: React.FC<{ className?: string; title: string; isShowDot: boolean; commentCount?: number }> = ({
    className,
    title,
    isShowDot,
    commentCount,
}) => {
    return (
        <div className={className}>
            <span>
                {title}
                {isShowDot && <ErrorDots className="error-dot" />}
            </span>
            {commentCount ? (
                <Text scale="caption500" color="neutralAction" className="comment-count">
                    {commentCount}
                </Text>
            ) : null}
        </div>
    )
}

export default styled(ErrorDotTitle)`
    position: relative;
    min-height: ${theme.newFontSizes.m};
    min-width: 1px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    .error-dot {
        position: absolute;
        top: 0;
    }
    .comment-count {
        width: 32px;
        height: 18px;
        gap: ${({ theme }) => theme.spacing[200]};
        border: 1px solid ${({ theme }) => theme.colors.border.primary};
        border-radius: 20px;
        text-align: center;
        box-sizing: border-box;
    }
`
